<script>
import axios from '@/utils/axios';


export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "Settings",
      text: "Administration",
      text1: "Settings",
      data: [],
      searchText: '',
      filterUser: '',
       pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
        },
    };
  },

  computed: {
filteredData() {
  let filtered = [...this.data];
  if (this.searchText) {
    const search = this.searchText.toLowerCase();
    filtered = filtered.filter(item =>
      item?.city?.toLowerCase().includes(search) ||
      item?.user?.name?.toLowerCase().includes(search)
    );
  }
  if (this.filterUser) {
    filtered = filtered.filter(item => item.user_id === this.filterUser);
  }
  return filtered;
},

uniqueUsers() {
  const map = {};
  this.data.forEach(item => {
    if (item.user) map[item.user_id] = item.user;
  });
  return Object.values(map);
},
  },

  mounted() {
    this.loadRules();
  },

  methods: {
    async loadRules() {
    this.setLoading(true);
    try {
        const response = await axios.get('/lead-assignment-location-rules');
        this.data = response.data.data.data;
        this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
        };
    } catch (error) {
        this.$swalToast(error.message, 'error');
    } finally {
        this.setLoading(false);
    }
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
      </div>

      <settings-tab></settings-tab>

      <div class="row">
        <crm-sidebar></crm-sidebar>

        <div class="col-xl-9">
          <div class="card">
            <div class="card-body">

              <div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
                <h4>Location wise Assignment <span class="text-muted fw-normal" style="font-size:14px;">({{ pagination.total }})</span></h4>
                <div>
                  <a href="javascript:void(0);" class="btn btn-primary d-flex align-items-center"
                    @click="$refs.locationRuleModal.openModal(); $openModal('location_rule_modal');">
                    <i class="ti ti-circle-plus me-2"></i>Add Rule
                  </a>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="card mb-0">

<div class="card-header d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center gap-2">
    <div class="input-icon-end position-relative">
      <input type="text" class="form-control" v-model="searchText" placeholder="Search by city or user..." style="width:250px;" />
      <span class="input-icon-addon"><i class="ti ti-search"></i></span>
    </div>
    <select class="form-select" v-model="filterUser" style="width:180px;">
      <option value="">All Users</option>
      <option :value="u.id" v-for="u in uniqueUsers" :key="u.id">{{ u.name }}</option>
    </select>
  </div>
</div>

                  <div class="custom-datatable-filter table-responsive">
                    <table class="table datatable thead-light" v-if="filteredData.length">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>City</th>
                          <th>User</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in filteredData" :key="row.id">
                          <td>{{ index + 1 }}.</td>
                          <td>
                            <span class="fw-medium">{{ row.city }}</span>
                          </td>
                          <td>
                            <div class="d-flex align-items-center gap-2">
                              <img :src="$profileImage(row.user?.image, clientAdmin)" width="22" class="rounded-circle" />
                              <span class="fw-medium">{{ row.user?.name }}</span>
                            </div>
                          </td>
                          <td>
                            <span class="badge rounded-pill" :class="row.is_active ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
                              {{ row.is_active ? 'Active' : 'Inactive' }}
                            </span>
                          </td>
                          <td>
                            <div class="action-icon d-inline-flex">
                              <!-- <a href="javascript:void(0);" class="me-2"
                                @click="$refs.locationRuleModal.editRule(row); $openModal('location_rule_modal');">
                                <i class="ti ti-edit"></i>
                              </a> -->
                              <a href="javascript:void(0);" class="text-danger"
                                @click="$refs.locationRuleModal.confirmDelete(row); $openModal('location_delete_modal');">
                                <i class="ti ti-trash"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div v-else class="p-3 text-center text-muted">
                      No records found.
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <lead-assignment-location-rule-modal ref="locationRuleModal" @updated="loadRules"></lead-assignment-location-rule-modal>
</template>